/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getNumStarted selector
 * @author Roland Scott
 * @module react-async-hook\api\selectors\get-num-started
 */

import { IAsyncState } from "../../types";
import { getNumStarted as internalGetNumStarted } from "../../internal/state/selectors";

/**
 * Get the number of async operations that have been started since we began tracking.
 * @param state The async state
 */
export function getNumStarted(state: IAsyncState): number {
	return internalGetNumStarted(state as any);
}
